import MoneyServiceDefault from "@/services/_bit/MoneyService";

class MoneyService extends MoneyServiceDefault {
  // You can redefine some part of default class here
}

export default new MoneyService();
